// Données fictives pour le Mode Démo
// Utilisées pour initialiser prospects/demoCompanies dans Firestore

export const DEMO_COMPANIES_DATA: Record<string, any> = {
  "Château Beaumont": {
    name: "Château Beaumont",
    siret: "452 891 234 00028",
    address: "Route du Château, BP 12",
    postalCode: "33250",
    city: "Pauillac",
    country: "FR",
    principalGender: "M.",
    principalContact: "Beaumont",
    principalFirstName: "Éric",
    principalPhone: "05 56 59 02 46",
    principalEmail: "contact@chateau-beaumont.fr",
    principalPosition: "Directeur d'exploitation",
    createdAt: new Date("2026-01-10"),
    updatedAt: new Date("2026-03-05"),
    opportunities: [
      {
        companyId: "Château Beaumont",
        contact: "Éric Beaumont",
        type: "FDA COLA (USA)",
        amount: 1450,
        date: "2026-03-05",
        qte: 1,
        pu: 1450,
        status: "Validée",
        description: "Enregistrement de 3 cuvées sur le marché américain",
      },
      {
        companyId: "Château Beaumont",
        contact: "Éric Beaumont",
        type: "TTB (USA)",
        amount: 890,
        date: "2026-03-20",
        qte: 1,
        pu: 890,
        status: "En cours",
      },
    ],
    invoices: [
      {
        id: "FAC-2026-0042",
        companyId: "Château Beaumont",
        opportunityType: "FDA COLA (USA)",
        qte: 1,
        pu: 1450,
        montantHT: 1450,
        montantTTC: 1740,
        date: new Date("2026-03-05"),
        updatedAt: new Date("2026-03-05"),
        status: "Réglée",
        montantFactureHT: 1450,
        montantFactureTTC: 1740,
      },
    ],
    devis: [
      {
        id: "DEV-2026-0037",
        companyId: "Château Beaumont",
        contact: "Éric Beaumont",
        opportunityType: "FDA COLA (USA)",
        amount: 1450,
        date: new Date("2026-03-01"),
        updatedAt: new Date("2026-03-01"),
        referenceDevis: "DEV-2026-0037",
      },
    ],
  },

  "Distillerie des Alpes": {
    name: "Distillerie des Alpes",
    siret: "789 234 561 00016",
    address: "23 chemin des Genévriers",
    postalCode: "74800",
    city: "Évian-les-Bains",
    country: "FR",
    principalGender: "Mme",
    principalContact: "Moreau",
    principalFirstName: "Claire",
    principalPhone: "04 50 75 18 33",
    principalEmail: "c.moreau@distillerie-alpes.fr",
    principalPosition: "Responsable Export",
    createdAt: new Date("2026-01-15"),
    updatedAt: new Date("2026-03-10"),
    opportunities: [
      {
        companyId: "Distillerie des Alpes",
        contact: "Claire Moreau",
        type: "CIFER (Chine)",
        amount: 2100,
        date: "2026-03-10",
        qte: 1,
        pu: 2100,
        status: "En cours",
        description: "Homologation gamme de spiritueux pour la Chine",
      },
    ],
    invoices: [
      {
        id: "FAC-2026-0058",
        companyId: "Distillerie des Alpes",
        opportunityType: "CIFER (Chine)",
        qte: 1,
        pu: 2100,
        montantHT: 2100,
        montantTTC: 2520,
        date: new Date("2026-03-10"),
        updatedAt: new Date("2026-03-10"),
        status: "En attente de Paiement",
        montantFactureHT: 2100,
        montantFactureTTC: 2520,
      },
    ],
    devis: [
      {
        id: "DEV-2026-0051",
        companyId: "Distillerie des Alpes",
        contact: "Claire Moreau",
        opportunityType: "CIFER (Chine)",
        amount: 2100,
        date: new Date("2026-03-08"),
        updatedAt: new Date("2026-03-08"),
        referenceDevis: "DEV-2026-0051",
      },
    ],
  },

  "Maison Lefranc & Fils": {
    name: "Maison Lefranc & Fils",
    siret: "321 654 987 00031",
    address: "8 rue du Commerce",
    postalCode: "21200",
    city: "Beaune",
    country: "FR",
    principalGender: "M.",
    principalContact: "Lefranc",
    principalFirstName: "Thomas",
    principalPhone: "03 80 22 67 89",
    principalEmail: "thomas.lefranc@lefranc-fils.fr",
    principalPosition: "Gérant",
    createdAt: new Date("2026-02-01"),
    updatedAt: new Date("2026-03-15"),
    opportunities: [
      {
        companyId: "Maison Lefranc & Fils",
        contact: "Thomas Lefranc",
        type: "Conseil réglementaire (heure)",
        amount: 350,
        date: "2026-03-15",
        qte: 2,
        pu: 175,
        status: "Validée",
        description: "Conseil sur la réglementation vins biologiques UE",
      },
      {
        companyId: "Maison Lefranc & Fils",
        contact: "Thomas Lefranc",
        type: "Abonnement à la Database",
        amount: 600,
        date: "2026-03-18",
        qte: 1,
        pu: 600,
        status: "En cours",
      },
    ],
    invoices: [
      {
        id: "FAC-2026-0063",
        companyId: "Maison Lefranc & Fils",
        opportunityType: "Conseil réglementaire (heure)",
        qte: 2,
        pu: 175,
        montantHT: 350,
        montantTTC: 420,
        date: new Date("2026-03-15"),
        updatedAt: new Date("2026-03-15"),
        status: "En attente de Paiement",
        montantFactureHT: 350,
        montantFactureTTC: 420,
      },
    ],
    devis: [
      {
        id: "DEV-2026-0068",
        companyId: "Maison Lefranc & Fils",
        contact: "Thomas Lefranc",
        opportunityType: "Conseil réglementaire (heure)",
        amount: 350,
        date: new Date("2026-03-12"),
        updatedAt: new Date("2026-03-12"),
        referenceDevis: "DEV-2026-0068",
      },
    ],
  },

  "BioSpirits International": {
    name: "BioSpirits International",
    siret: "567 123 890 00044",
    address: "45 avenue de la Liberté",
    postalCode: "67000",
    city: "Strasbourg",
    country: "FR",
    principalGender: "M.",
    principalContact: "Wagner",
    principalFirstName: "Marc",
    principalPhone: "03 88 61 42 10",
    principalEmail: "m.wagner@biospirits-intl.com",
    principalPosition: "PDG",
    createdAt: new Date("2026-02-10"),
    updatedAt: new Date("2026-03-25"),
    opportunities: [
      {
        companyId: "BioSpirits International",
        contact: "Marc Wagner",
        type: "FDA COLA (USA)",
        amount: 2900,
        date: "2026-03-25",
        qte: 2,
        pu: 1450,
        status: "En cours",
        description: "Enregistrement gamme gin bio marché américain",
      },
    ],
    invoices: [
      {
        id: "FAC-2026-0071",
        companyId: "BioSpirits International",
        opportunityType: "FDA COLA (USA)",
        qte: 2,
        pu: 1450,
        montantHT: 2900,
        montantTTC: 3480,
        date: new Date("2026-03-25"),
        updatedAt: new Date("2026-03-25"),
        status: "En attente de Paiement",
        montantFactureHT: 2900,
        montantFactureTTC: 3480,
      },
    ],
    devis: [
      {
        id: "DEV-2026-0065",
        companyId: "BioSpirits International",
        contact: "Marc Wagner",
        opportunityType: "FDA COLA (USA)",
        amount: 2900,
        date: new Date("2026-03-20"),
        updatedAt: new Date("2026-03-20"),
        referenceDevis: "DEV-2026-0065",
      },
    ],
  },
};
